import { lazy, ComponentType } from 'react';

// After a deploy, browsers holding a cached index.html request content-hashed
// chunk files that no longer exist. The failed dynamic import would otherwise
// crash the route; instead, reload once so the browser picks up the new
// index.html. A session marker prevents reload loops.

const RELOAD_MARKER = 'chunk_load_reload_at';
const RELOAD_COOLDOWN_MS = 60 * 1000;

export const retryImport = async <T>(factory: () => Promise<T>): Promise<T> => {
  try {
    return await factory();
  } catch (error) {
    let lastReload = 0;
    try {
      lastReload = Number(sessionStorage.getItem(RELOAD_MARKER) || 0);
    } catch {}

    if (Date.now() - lastReload > RELOAD_COOLDOWN_MS) {
      try {
        sessionStorage.setItem(RELOAD_MARKER, String(Date.now()));
      } catch {}
      window.location.reload();
      // The page is reloading — never settle so no error UI flashes
      return new Promise<T>(() => {});
    }

    throw error;
  }
};

export const lazyWithRetry = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) => lazy(() => retryImport(factory));
